import { CSSProperties } from "react";
import { cn, incPanelColorLevel, panelBackgroundStyles } from "../../../styles";
import { PanelColor } from "../../../props";
import { FrozenCellInfo } from "../hooks/useFrozenColumns";

export function frozenCellStyle(info: FrozenCellInfo | undefined): CSSProperties | undefined {
  if (!info) return undefined;
  return {
    position: "sticky",
    [info.side]: info.offset,
    zIndex: 1,
  };
}

export function frozenCellClassName(info: FrozenCellInfo | undefined): string | undefined {
  if (!info) return undefined;
  return cn(
    info.edge &&
      (info.side === "left"
        ? "shadow-[4px_0_6px_-4px_rgba(0,0,0,0.25)]"
        : "shadow-[-4px_0_6px_-4px_rgba(0,0,0,0.25)]"),
  );
}

// The single source of truth for a row's background. It must be opaque: frozen
// cells repaint it on their own <td>, and anything translucent would let the
// columns sliding underneath show through during horizontal scroll. The row and
// its frozen cells therefore always resolve to the exact same class.
export function rowBackgroundClassName(
  color: PanelColor,
  isSelected: boolean,
  isOddStripe: boolean,
): string {
  if (isSelected) return "bg-primary-100 dark:bg-primary-900";
  if (isOddStripe) return panelBackgroundStyles[incPanelColorLevel(color, 1)];
  return panelBackgroundStyles[color];
}
